export default {
  path: 'ingredient-category',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'IngredientCategoryList',
      component: () => import('@/views/settingSystem/pages/ingredient-category/IngredientCategoryList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'IngredientCategoryCreate',
      component: () => import('@/views/settingSystem/pages/ingredient-category/IngredientCategoryCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'IngredientCategoryEdit',
      component: () => import('@/views/settingSystem/pages/ingredient-category/IngredientCategoryEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
